import { createRouter, createWebHistory } from 'vue-router'
import { publicRoutes } from './routes/public.routes'
import { authRoutes } from './routes/auth.routes'
import { adminRoutes } from './routes/admin.routes'
import { setupRouterGuards } from './guards'
import cabinetRoutes from './routes/cabinet.routes'
import { catalogScrollPolicy } from './scroll'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: catalogScrollPolicy.scrollBehavior,
  routes: [
    ...publicRoutes,
    ...authRoutes,
    ...adminRoutes,
    ...cabinetRoutes
  ]
})

// Cancel pending catalog scrolls as soon as another navigation starts.
router.beforeEach(() => { catalogScrollPolicy.cancel() })
setupRouterGuards(router)

export default router
